/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 43f96b2d (Wed Dec  3 21:51:26 UTC 2025)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  ServerStatusVersion,
  ServerStatusVersionFromJSON,
  ServerStatusVersionToJSON,
} from './'

/**
 *
 * @export
 * @interface ServerStatus
 */
export interface ServerStatus {
  /**
   *
   * @type string
   * @memberof ServerStatus
   */
  status?: ServerStatusStatusEnum
  /**
   *
   * @type ServerStatusVersion
   * @memberof ServerStatus
   */
  version?: ServerStatusVersion
}

/**
 * @export
 * @enum {string}
 */
export enum ServerStatusStatusEnum {
  Online = 'online',
}

export function ServerStatusFromJSON(json: any): ServerStatus {
  return ServerStatusFromJSONTyped(json, false)
}

export function ServerStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ServerStatus {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    version: !exists(json, 'version')
      ? undefined
      : ServerStatusVersionFromJSON(json['version']),
  }
}

export function ServerStatusToJSON(value?: ServerStatus | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    version: ServerStatusVersionToJSON(value.version),
  }
}
